export default "__VITE_ASSET__DDAqiRlK__"